export default __webpack_public_path__ + "static/media/3caaee14a0fe97a2.88b5d6cfa40aff44116a034ed69bfa37.svg";